import { useEffect, useState } from "react";
import { FiXCircle } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import moment from "moment";

// import { setVKYCStep } from "../../redux/slices/userSlice";

import styles from "./VideoKyc.module.scss";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { setVKYCStep } from "../../redux/slices/userSlice";

export default function VKYCRejected() {
  const [data, setData] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { transaction_id, vkyc_status, api_response } = location.state || {};

  const transactionID = transaction_id || localStorage.getItem("transaction_id");

  const vkycStatus = vkyc_status || localStorage.getItem("vkyc_status");

  useEffect(() => {
    dispatch(setVKYCStep("VKYC_REJECTED"));

    if (transactionID && vkycStatus) {
      fetchStatusDetails();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionID, vkycStatus, dispatch]);

  const fetchStatusDetails = async () => {
    handleShowContextualLoader();

    const { vkycStatusDetailsAPI } = new AfterOnboardAPI();

    try {
      const res = await vkycStatusDetailsAPI(transactionID, vkycStatus, api_response);

      setData(res.data);
    } catch (error) {
      console.error("VKYC rejected error:", error);
    } finally {
      handlehideContextualLoader();
    }
  };

  // Logout handler
  const handleLogout = () => {
    dispatch(setVKYCStep(""));
    navigate("/logout");
  };

  return (
    <div className="wrapper">
      <main className={styles.page}>
        {/* Main Content */}
        <section className={styles.content}>
          {/* Rejected Icon */}
          <div className={`${styles.statusIcon} ${styles.statusIconRejected}`}>
            <FiXCircle size={40} />
          </div>

          {/* Status Badge */}
          <div className={`${styles.statusPill} ${styles.statusPillRejected}`}>REJECTED</div>

          {/* Heading */}
          <h1 className={styles.title}>Video KYC Rejected</h1>

          {/* Description */}
          <p className={styles.description}>Your application cannot proceed further via Video KYC. Please contact our support team for further assistance regarding your loan application.</p>

          {/* Details Card */}
          <div className={styles.detailsCard}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Session ID</span>

              <strong className={styles.detailValue}>{data?.vkyc_transaction_id || "-"}</strong>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Timestamp</span>

              <strong className={styles.detailValue}>{data?.vkyc_initiate_date ? moment(data.vkyc_initiate_date).format("DD-MM-YYYY HH:mm:ss") : "-"}</strong>
            </div>

            <div className={`${styles.detailRow} ${styles.detailRowLast}`}>
              <span className={styles.detailLabel}>Loan amount</span>

              <strong className={styles.loanAmount}>₹{data?.approved_loan_amount || 0}</strong>
            </div>
          </div>
        </section>

        {/* Fixed Bottom Button */}
        <div className={styles.footer}>
          <button type="button" className={styles.actionButton} onClick={handleLogout}>
            Log Out
          </button>
        </div>
      </main>
    </div>
  );
}
